export default __webpack_public_path__ + "static/media/group-10@2x1.4f3ab9aa.png";